import { render, staticRenderFns } from "./TargetKPI.vue?vue&type=template&id=528291d6&"
import script from "./TargetKPI.vue?vue&type=script&lang=js&"
export * from "./TargetKPI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports